import React, { useState } from 'react';

const STORAGE_KEY = 'kinestex_outdated_notice_dismissed';

const OutdatedBanner: React.FC = () => {
  const [visible, setVisible] = useState<boolean>(() => {
    try {
      return sessionStorage.getItem(STORAGE_KEY) !== 'true';
    } catch {
      return true;
    }
  });

  const handleContinue = () => {
    try {
      sessionStorage.setItem(STORAGE_KEY, 'true');
    } catch {
      // Ignore storage errors (e.g. private mode) and just dismiss.
    }
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="outdated-banner-title"
    >
      <div className="w-full max-w-md rounded-xl bg-white p-6 shadow-xl">
        <h2
          id="outdated-banner-title"
          className="mb-3 text-lg font-bold text-gray-900"
        >
          This content is out of date
        </h2>

        <p className="mb-4 text-sm leading-relaxed text-gray-600">
          The plans, workouts, and exercises shown here are no longer maintained.
          The IDs in this panel still work for backwards compatibility, but we've
          moved to a new numeric ID system.
        </p>

        <p className="mb-5 text-sm leading-relaxed text-gray-600">
          For the latest content and their current IDs, use our admin dashboard:{' '}
          <a
            href="https://admin.kinestex.com"
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium text-blue-600 hover:underline"
          >
            admin.kinestex.com
          </a>
        </p>

        <button
          onClick={handleContinue}
          className="w-full rounded-lg bg-blue-500 px-4 py-2 font-medium text-white transition-colors hover:bg-blue-600"
        >
          Continue to browse
        </button>
      </div>
    </div>
  );
};

export default OutdatedBanner;
